import React, {ReactNode} from 'react';
import clsx from 'clsx';
import {DialogSize} from './dialog';

interface DialogFooterProps {
  children: ReactNode;
  startAction?: ReactNode;
  className?: string;
  dividerTop?: boolean;
  size?: DialogSize;
  padding?: string;
}
export function DialogFooter(props: DialogFooterProps) {
  const {children, startAction, className, dividerTop, padding, size} = props;

  return (
    <div
      className={clsx(
        className,
        'dlg-footer flex items-center gap-10 flex-shrink-0',
        getPadding(props)
      )}
    >
      <div>{startAction}</div>
      <div className="ml-auto flex items-center gap-10">{children}</div>
    </div>
  );
}

function getPadding({padding, size}: DialogFooterProps) {
  if (padding) {
    return padding;
  }
  switch (size) {
    case 'xs':
      return 'px-14 py-10';
    case 'sm':
      return 'px-18 py-10';
    default:
      return 'px-20 py-14';
  }
}
